import { createContext } from "react";
import IPolicyContext from "../../modal/PolicyModal";

const defaultState: IPolicyContext = {
  selectedPolicy: [],
  previewPolicy: {},
};

const PolicyContext = createContext<IPolicyContext>(defaultState);

export default PolicyContext;
